export default "__VITE_ASSET__448784d1__"